import { Page, PageTitleWithBack } from '../../../components';
import { EmailTestsForm } from './email-tests-form';

export const EmailTestsPage = () => {
  return (
    <>
      <Page title="Email Tests">
        <PageTitleWithBack backText="Back to Admin" backUrl={'/admin'} title="Email Tests" />
        <EmailTestsForm />
      </Page>
    </>
  );
};
